// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/react-scripts/node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/react-scripts/node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.main-menu .fa {
    position: relative;
    display: table-cell;
    width: 60px;
    height: 36px;
    text-align: center;
    vertical-align: middle;
    font-size: 18px;
  }
  
  
  .main-menu:hover,
  nav.main-menu.expanded {
    width: 60px;
    overflow: visible;
    background: #32879c;
  }
  
  .main-menu {
  
    position: fixed;
    top: 0;
    bottom: 0;
    height: 100%;
    left: 0;
    width: 2px;
    overflow: hidden;
    transition: width .05s linear;
    -webkit-transform: translateZ(0) scale(1, 1);
    z-index: 1000;
  }
  
  .main-menu>ul {
    margin: 7px 0;
  }
  
  .main-menu li {
    position: relative;
    display: block;
    width: 60px;
  }
  
  .main-menu li>a img {
    width: 25px;
  
  }
  
  .main-menu li>a {
    position: relative;
    display: table;
    border-collapse: collapse;
    border-spacing: 0;
    color: #fff;
    font-family: arial;
    font-size: 14px;
    text-decoration: none;
    -webkit-transform: translateZ(0) scale(1, 1);
    transition: all .1s linear;
    display: block;
    text-align: center;
    padding: 8px;
  
  }
  
  
  
  .main-menu .nav-text {
    position: relative;
    display: table-cell;
    vertical-align: middle;
    width: 0px;
    font-family: 'Titillium Web', sans-serif;
  }
  
  `, "",{"version":3,"sources":["webpack://./src/componets/Dashboard/DashboardMain/Sidebar.css"],"names":[],"mappings":"AAAA;IACI,kBAAkB;IAClB,mBAAmB;IACnB,WAAW;IACX,YAAY;IACZ,kBAAkB;IAClB,sBAAsB;IACtB,eAAe;EACjB;;;EAGA;;IAEE,WAAW;IACX,iBAAiB;IACjB,mBAAmB;EACrB;;EAEA;;IAEE,eAAe;IACf,MAAM;IACN,SAAS;IACT,YAAY;IACZ,OAAO;IACP,UAAU;IACV,gBAAgB;IAEhB,6BAA6B;IAC7B,4CAA4C;IAC5C,aAAa;EACf;;EAEA;IACE,aAAa;EACf;;EAEA;IACE,kBAAkB;IAClB,cAAc;IACd,WAAW;EACb;;EAEA;IACE,WAAW;;EAEb;;EAEA;IACE,kBAAkB;IAClB,cAAc;IACd,yBAAyB;IACzB,iBAAiB;IACjB,WAAW;IACX,kBAAkB;IAClB,eAAe;IACf,qBAAqB;IACrB,4CAA4C;IAE5C,0BAA0B;IAC1B,cAAc;IACd,kBAAkB;IAClB,YAAY;;EAEd;;;;EAIA;IACE,kBAAkB;IAClB,mBAAmB;IACnB,sBAAsB;IACtB,UAAU;IACV,wCAAwC;EAC1C","sourcesContent":[".main-menu .fa {\r\n    position: relative;\r\n    display: table-cell;\r\n    width: 60px;\r\n    height: 36px;\r\n    text-align: center;\r\n    vertical-align: middle;\r\n    font-size: 18px;\r\n  }\r\n  \r\n  \r\n  .main-menu:hover,\r\n  nav.main-menu.expanded {\r\n    width: 60px;\r\n    overflow: visible;\r\n    background: #32879c;\r\n  }\r\n  \r\n  .main-menu {\r\n  \r\n    position: fixed;\r\n    top: 0;\r\n    bottom: 0;\r\n    height: 100%;\r\n    left: 0;\r\n    width: 2px;\r\n    overflow: hidden;\r\n    -webkit-transition: width .05s linear;\r\n    transition: width .05s linear;\r\n    -webkit-transform: translateZ(0) scale(1, 1);\r\n    z-index: 1000;\r\n  }\r\n  \r\n  .main-menu>ul {\r\n    margin: 7px 0;\r\n  }\r\n  \r\n  .main-menu li {\r\n    position: relative;\r\n    display: block;\r\n    width: 60px;\r\n  }\r\n  \r\n  .main-menu li>a img {\r\n    width: 25px;\r\n  \r\n  }\r\n  \r\n  .main-menu li>a {\r\n    position: relative;\r\n    display: table;\r\n    border-collapse: collapse;\r\n    border-spacing: 0;\r\n    color: #fff;\r\n    font-family: arial;\r\n    font-size: 14px;\r\n    text-decoration: none;\r\n    -webkit-transform: translateZ(0) scale(1, 1);\r\n    -webkit-transition: all .1s linear;\r\n    transition: all .1s linear;\r\n    display: block;\r\n    text-align: center;\r\n    padding: 8px;\r\n  \r\n  }\r\n  \r\n  \r\n  \r\n  .main-menu .nav-text {\r\n    position: relative;\r\n    display: table-cell;\r\n    vertical-align: middle;\r\n    width: 0px;\r\n    font-family: 'Titillium Web', sans-serif;\r\n  }\r\n  \r\n  "],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
